module.exports = __webpack_public_path__ + "images/help/video-permission-small-0651b52003ffbd7a2b5d5e860d2470c0.png";